<div *ngIf="showIndicator" class="alert alert-fraud" role="alert">
  <h4>Possible Fraud</h4>
  <div>The participant for this item has a fraud score that exceeds the threshold set for this promotion. Please review carefully and proceed with caution. <small class="pull-right"><span title="Current Fraud Score">{{ fraudScore }}</span> / <span title="Fraud Threshold Setting">{{ fraudThreshold }}</span></small></div>
</div>
